import React from 'react';
import PropTypes from 'prop-types';
import { Route, Router as VendorRouter, Switch } from 'react-router-dom';

import { history, routes } from './routes';
import { ScrollToTop } from './ScrollToTop';

const zipRouteData = routeData => (
  routeData.map((data) => {
    const route = routes.find(r => r.name === data.name);
    return {
      ...data,
      ...route,
    };
  })
);

const renderRoutes = routeData => (
  zipRouteData(routeData).map(data => (
    <Route
      key={data.path}
      exact
      path={data.path}
      component={data.component}
    />
  ))
);

const routeConfigTemplate = {
  name: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

const IPropTypes = {
  routeConfig: PropTypes.arrayOf(PropTypes.shape(routeConfigTemplate)).isRequired,
};

const Router = props => (
  <VendorRouter history={history}>
    <ScrollToTop>
      <Switch>
        {renderRoutes(props.routeConfig)}
      </Switch>
    </ScrollToTop>
  </VendorRouter>
);

Router.propTypes = IPropTypes;

export { Router };




// WEBPACK FOOTER //
// ./src/routes/Router.jsx